// The code in this file will load on every page of your site
import { session } from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {
    
	// Option 1 - save the params as a parsed object with fields
	//const params = wixLocation.query;
    //const paramsText = JSON.stringify(params);

    //if (paramsText !== '{}') {
        //session.setItem("myUrlParams", paramsText);
    //}

	/********************************************************************/
	
	//  Option 2 - take the params string as is
	const url = wixLocation.url;
	const index = url.indexOf('?');
	if(index >= 0){
		const urlParamsText = url.substr(index);
		session.setItem("myUrlParamsText", urlParamsText);
	}
});